import * as React from "react";
import { Id } from "@repo/convex/convex/_generated/dataModel";
import { Dialog, Flex } from "@radix-ui/themes";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { ItemContentSection } from "./ItemContentSection.tsx";
import { ItemDebugSection } from "./ItemDebugSection.tsx";
import { DialogCloseButton } from "../common/DialogCloseButton.tsx";
import { itemTitle } from "../common/items/format.ts";

interface Props {
  itemId: Id<"items"> | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => unknown;
}

export const ItemDetailsDialog: React.FC<Props> = ({ isOpen, itemId, setIsOpen }) => {
  const item = useQuery(api.items.findMine, itemId ? { itemId } : "skip");
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(isOpen) => {
        if (!itemId) return;
        setIsOpen(isOpen);
      }}
    >
      <Dialog.Content maxWidth="760px">
        <Dialog.Title mb={"1"}>Details</Dialog.Title>
        <Dialog.Description color={"gray"} size={"2"} mb={"4"}>
          {item ? itemTitle(item) : "\u00a0"}
        </Dialog.Description>
        <DialogCloseButton onClick={() => setIsOpen(false)} />

        {itemId && (
          <Flex direction={"column"} gap={"5"}>
            <ItemContentSection itemId={itemId} />
            <ItemDebugSection itemId={itemId} />
          </Flex>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};
